(() => {
  if (customElements.get('recommendations-products')) {
    return;
  }

  class RecommendationsProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.get();
        },
        { rootMargin: '0px 0px 400px 0px' }
      ).observe(this);
    }

    get() {
      fetch(this.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.innerHTML = html.querySelector('recommendations-products').innerHTML
      })
    }
  }

  customElements.define('recommendations-products', RecommendationsProducts);
})();
